/* global toastr -- provided by the page (a Blade-injected value or a third-party script tag), not declared in this file */
import Swal from 'sweetalert2';
import { failure } from '@common/alert';

const dismissals = [
    Swal.DismissReason.backdrop,
    Swal.DismissReason.cancel,
    Swal.DismissReason.close,
    Swal.DismissReason.esc,
    Swal.DismissReason.timer,
];

export function errorHandler(err) {
    if (dismissals.includes(err)) {
        return;
    }

    if (err.responseJSON) {
        // Handle backend form validation errors
        if (err.responseJSON.errors) {
            backendErrorHandler(err.responseJSON.errors);
            return;
        }

        if (err.responseJSON.message) {
            failure(err.responseJSON.message);
            return;
        }

        // TODO(derrick): Standardize this with the above.
        if (err.responseJSON.msg) {
            failure(err.responseJSON.msg);
            return;
        }
    }

    if (typeof err === 'string') {

        console.error(err);

    } else {

        console.error('Unknown error', err);

    }

    failure('Oops! Something went wrong.');
}

export const slugifyError = error =>
    error.toLowerCase()
        .replace(/[^a-z0-9_-]+/g, '-')
        .replace(/-+/g, '-');

export const backendErrorHandler = (errArr, $form) => {
    const $scope = $form ?? $(document);

    Object.keys(errArr).forEach((fieldName) => {
        // Converts "foo.bar" into "foo[bar]"
        const inputName = fieldName.split('.')
            .map((s, i) => i === 0 ? s : `[${s}]`)
            .join('');
        let $input = $scope.find(`:input[name="${inputName}"]`);

        if ($input.length !== 1) {
            // Field name doesn't exist OR it's duplicated.
            toastr.error(errArr[fieldName][0]);
            return;
        }

        const $field = $input.parsley();

        if (!$field) {
            // Parsley isn't initialized.
            toastr.error(errArr[fieldName][0]);
            return;
        }

        $field.addError(
            slugifyError(errArr[fieldName][0]),
            { message: errArr[fieldName][0] },
        );

        if ($input.is('select')) {
            $input = $input.closest('.select-wrapper');
        }

        $input.siblings('.help-text').hide();
    });
};
